import React from 'react';
import { Card, Tabs, Tab } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import RecentClaimGroups from './RecentClaimGroups';
import RecentCompanies from './RecentCompanies';
const RecentActivity = _ref => {
  let {
    claimGroups,
    recentClaimGroupIds,
    companies,
    recentCompanyIds,
    accountType
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Card, {
    className: "px-4 py-3 h-100"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "font-weight-bold"
  }, t('recent_activity')), /*#__PURE__*/React.createElement(Tabs, {
    className: "mb-2",
    defaultActiveKey: 'claim_groups'
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "claim_groups",
    title: t('claim_groups')
  }, /*#__PURE__*/React.createElement(RecentClaimGroups, {
    claimGroups: claimGroups,
    recentClaimGroupIds: recentClaimGroupIds,
    accountType: accountType
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "companies",
    title: t('companies')
  }, /*#__PURE__*/React.createElement(RecentCompanies, {
    companies: companies,
    recentCompanyIds: recentCompanyIds
  }))));
};
export default RecentActivity;